// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Progress } from 'semantic-ui-react';
// local
import NotificationTimeout from 'app/ui/commons/notification/NotificationTimeout';
import Snackbar from 'app/ui/commons/snackbar/Snackbar';
import './Page.scss';

class Page extends Component {
    render() {
        const { id, loading, children } = this.props;
        return (
            <div id={id} className="page">
                {loading && <Progress size="tiny" percent={100} color="teal" indicating />}
                <NotificationTimeout />
                <Snackbar />
                {children}
            </div>
        );
    }
}

Page.propTypes = {
    id: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    children: PropTypes.any,
};

export default Page;
